export default function() {
	const $footerBlock = $('.footer');
	const $ymBanner = $footerBlock.find('.footer__ym-banner');

	if ($ymBanner.length > 0) {
		const $bannerContent = $ymBanner.data('content');

		function loadBanner() {
			const $window = $(window);
			const height = $window.height();
			const scroll_top = $window.scrollTop();
			const position = $ymBanner.offset();

			if (position.top - 500 < scroll_top + height) {
				$ymBanner.html($bannerContent);
				$ymBanner.removeAttr('data-content');
				$(window).off('scroll', loadBanner);
			}
		}

		function addPadding() {
			const $fixedBar = $('.fixed-bar');
			const $addCartBlock = $('.to-cart__buy--main');

			let height = 0;

			if ($fixedBar.length > 0) {
				height = height + $fixedBar.outerHeight();
			}

			if ($addCartBlock.length > 0 && !$addCartBlock.hasClass('to-cart__buy--fixed')) {
				ObserverUtil.observeClass('to-cart__buy--main', function () {
					if ($addCartBlock.hasClass('to-cart__buy--fixed')) {
						height = height + $addCartBlock.outerHeight();

						if (height > 0) {
							$footerBlock.css('padding-bottom', height+'px');
						}
					}
				});
			} else {
				if ($addCartBlock.length > 0) {
					height = height + $addCartBlock.outerHeight();
				}

				if (height > 0) {
					$footerBlock.css('padding-bottom', height+'px');
				}
			}
		}

		addPadding();
		loadBanner();
		$(window).on('scroll', loadBanner);
	}
}
